var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "m-update-form" }, [_c('h4', [_vm._v("请选择测试：")]), _vm._v(" "), _c('dynamic-form', { ref: "form", attrs: { "form-config": _vm.formConfig, "form-value": _vm.formValue, "form-item-list": _vm.formItem } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };